import React from "react";

const NewLineText = ({ text }) => {
    return text.split('\n').map(str => <div>{str}</div>);
};

export default NewLineText;
